// extracted by mini-css-extract-plugin
export default {"dashboard":"OverviewSection_dashboard__X8Gar"};